module.exports = __webpack_public_path__ + "static/img/6.8573858.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/benjyfishy/6.png
// module id = ijvO
// module chunks = 35